import {
  AGENTS,
  DEFAULT_EFFORT,
  DEFAULT_MODEL,
  EFFORTS,
  MODELS,
  VISIBLE_AGENTS,
  agentForModel,
  canonicalizeModel,
  coerceEffort,
  defaultEffortFor,
  effortsFor,
  enabledAgents,
  enabledModelsForAgent,
  isEffortId,
  isHiddenAgent,
  modelsForAgent,
  labelForModelEffort,
  modelLabel,
  effortLabel,
  nextVisibleAgent,
  resolvedModel,
  rotateSessionPrefs,
  setDiscoveredModels,
  type CatalogModelId,
  type EffortId,
  type ModelId,
  type ModelRow,
  type PrefAxis,
} from '../../../server/src/models.ts';

export {
  AGENTS,
  DEFAULT_EFFORT,
  DEFAULT_MODEL,
  EFFORTS,
  MODELS,
  VISIBLE_AGENTS,
  agentForModel,
  canonicalizeModel,
  coerceEffort,
  defaultEffortFor,
  effortsFor,
  enabledAgents,
  enabledModelsForAgent,
  isHiddenAgent,
  labelForModelEffort,
  modelLabel,
  effortLabel,
  modelsForAgent,
  nextVisibleAgent,
  resolvedModel,
  rotateSessionPrefs,
  setDiscoveredModels,
  type CatalogModelId,
  type EffortId,
  type ModelId,
  type ModelRow,
  type PrefAxis,
};

export const MODEL_KEY = 'preferred-model';
export const EFFORT_KEY = 'preferred-effort';

export function readStoredModel(): ModelId {
  const raw = localStorage.getItem(MODEL_KEY);
  const id = (raw && canonicalizeModel(raw)) || DEFAULT_MODEL;
  return isHiddenAgent(agentForModel(id)) ? DEFAULT_MODEL : id;
}

export function readStoredEffort(model: ModelId = readStoredModel()): EffortId | null {
  const raw = localStorage.getItem(EFFORT_KEY);
  return coerceEffort(model, isEffortId(raw) ? raw : null);
}

/** Keep a chat on a model you can still pick; fall back to the first one left on. */
export function enabledModel(model: ModelId, enabled: readonly string[]): ModelId {
  if (enabled.length === 0 || enabled.includes(model)) return model;
  const sameAgent = enabledModelsForAgent(agentForModel(model), enabled)[0];
  return sameAgent?.id ?? enabled[0]!;
}
